import { useState, useEffect } from "react";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $generateHtmlFromNodes, $generateNodesFromDOM } from "@lexical/html";
import { $insertNodes } from "lexical";

interface Props {
    initialHtml?: string;
    onHtmlChanged: (html: string) => void;
}

export const HtmlPlugin = ({ initialHtml, onHtmlChanged }: Props) => {
    const [editor] = useLexicalComposerContext();

    const [isFirstRender, setIsFirstRender] = useState(true);

    const unwrapNode = (element: Element) => {
        let text = "";
        const stack = []
        if (!element.children.length) {
            text += element.innerHTML
        }
        for (let child of (element.children as any)) {
            stack.push(child)
        }   
        for (let childitem of stack) {
            if (childitem.tagName === 'SPAN') {
                text += childitem.innerHTML
            }
            if (childitem.tagName === 'B') {
                text += '<b>' + childitem.children[0].innerHTML + '</b>'
            }
            if (childitem.tagName === 'BR') {
                text += '\n'
            }
            if (childitem.tagName === 'EM') {
                text += childitem.innerHTML
            }
            if (childitem.tagName === 'I') {
                if (childitem.children.length) {
                    text += '<i>' + unwrapNode(childitem) + '</i>'
                } else {
                    text += '<i>' + childitem.innerHTML + '</i>'
                }
            }         
            if (childitem.tagName === 'U') {
                if (childitem.children.length) {
                    text += '<u>' + unwrapNode(childitem) + '</u>'
                } else {
                    text += '<u>' + childitem.innerHTML + '</u>'
                }
            }         
            if (childitem.tagName === 'S') {
                if (childitem.children.length) {
                    text += '<s>' + unwrapNode(childitem) + '</s>'
                } else {
                    text += '<s>' + childitem.innerHTML + '</s>'
                }
            }         
            if (childitem.tagName === 'A') {
                if (childitem.children.length) {
                    text += `<a href="${childitem.href}">` + unwrapNode(childitem) + '</a>'
                } else {
                    text += `<a href="${childitem.href}">` + childitem.innerHTML + '</a>'
                }
            }         
        }
        return text
    }

    const toTelegramFormat = (content: string) => {
        const parser = new DOMParser();
        const dom = parser.parseFromString(content, "text/html")
        const collection = dom.body.children;
        let text = "";
        for (let i = 0; i < collection.length; i++) {
            const item = collection[i]
            if (i < collection.length) {
                text += '\n'
            }
            if (item.tagName === 'P') {
                text += unwrapNode(item)
            }
            if (item.tagName === 'BLOCKQUOTE') {
                text += '<blockquote>' + unwrapNode(item)  + '</blockquote>'
            }
        }
        return text
    }

    useEffect(() => {
        if (!initialHtml || !isFirstRender) return;

        setIsFirstRender(false);
        
        editor.update(() => {
            const parser = new DOMParser();
            const dom = parser.parseFromString(initialHtml, "text/html");
            const nodes = $generateNodesFromDOM(editor, dom);
            $insertNodes(nodes);
        });
    }, []);

    return (
        <OnChangePlugin
            onChange={(editorState) => {
                editorState.read(() => {
                    onHtmlChanged(toTelegramFormat($generateHtmlFromNodes(editor)));
                });
            }}
        />
    );
};
